import Stack from "@mui/material/Stack";
import { Button, Input, Modal } from "@vv/ui";
import { useState } from "react";

export interface RequestReworkModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

export function RequestReworkModal({ open, onClose, onConfirm }: RequestReworkModalProps) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleConfirm() {
    setSaving(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
    } catch {
      // Already toasted by the caller's runAction() - swallow so it doesn't
      // also surface as an unhandled promise rejection.
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Request rework"
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            color="warning"
            loading={saving}
            disabled={reason.trim().length === 0}
            onClick={handleConfirm}
          >
            Request rework
          </Button>
        </>
      }
    >
      <Stack spacing={2} sx={{ pt: 1 }}>
        <Input
          label="Review comments / reason for rework"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          multiline
          minRows={3}
          required
          autoFocus
        />
      </Stack>
    </Modal>
  );
}
